import React from 'react';
import AuthenticatedPage from "../../ContextAndHOC/AuthenticatedPage";
import { Field } from "formik";
import Textfield from "../../components/formikcomponent/TextField";
import { makeStyles, } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  inputItem: { width: "100%" }
}));

const ResourceId = (props) => {
  const classes = useStyles();
  const [error, setError] = React.useState('');
  const getfield = async (event) => {
    let resourceId = event.target.value;
    let url = `/api/content/contentservice/isResourceIdIsUsed`;
    let response = await props.authenticatedApiCall("post", url, { resourceId });
    if (response && response.data.isResourceIdUsed) {
      props.setFieldErrors("resourceid", 'Content Id already Exists');
      setError('Content Id already Exists');
    } else {
      props.setFieldErrors("resourceid", '');
      setError('');
    }
  };
  return (
    <Field
      name={"resourceid"}
      type="text"
      component={Textfield}
      variant="filled"
      label="Content ID *"
      disabled={props.disabled()}
      className={classes.inputItem}
      onBlur={(event) => { getfield(event); }}
      validate={async (resourceId) => {
        if (error) {
          return (error);
        }
      }}
    />
  );
};


export default AuthenticatedPage()(ResourceId);